var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"component-leadoptype"},[(_vm.leadOpType)?_c('v-chip',{staticClass:"mr-1",attrs:{"label":"","dark":"","color":"light-blue","x-small":"","outlined":""},domProps:{"textContent":_vm._s(_vm.opTypeLong)}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }